import React, { useEffect, useState } from 'react'
import axios from 'axios'

import ErrorComponent from '../Error'
import LoadingComponent from '../Loading'

import '../styles/fpren_currents.css'
import helpers from '../utils/helpers'

export default function Currents({ userLocation }) {
  const [ lat, lon ] = userLocation
  const [ error, setError ] = useState(null)
  const [ isLoaded, setIsLoaded ] = useState(false)
  const [ currents, setCurrents ] = useState({})

  useEffect(() => {

    axios.get(`https://pbsweather.org/shared/server/metar_nearest.php?lat=${lat}&lon=${lon}`)
      .then(
        res => {
          setIsLoaded(true)
          const observation = res.data.metars.data

          setCurrents({
            location: helpers.convertToMixedCase(observation.station ? observation.station.name.split(',')[0] : 'Station name not listed'),
            time: helpers.convertToTime(observation.issuetime ? observation.issuetime : 'N/A').withMins,
            weather: observation.weather_code ? observation.weather_code.text : 'N/A',
            weatherCode: helpers.getMetarIcon(
              observation.weather_code ? observation.weather_code.value : 'N/A', 
              observation.hasOwnProperty('daylight') ? observation.daylight : true
            ),
            temperature: helpers.convertTemperature(observation.temperature ? observation.temperature.value : 'N/A').fahrenheit,
            windChill: helpers.convertTemperature(observation.temperature ? observation.temperature.wind_chill : 'N/A').fahrenheit,
            heatIndex: helpers.convertTemperature(observation.temperature ? observation.temperature.heat_index : 'N/A').fahrenheit,
            dewpoint: helpers.convertTemperature(observation.temperature? observation.temperature.dew_point : 'N/A').fahrenheit,
            windDirection: helpers.convertDirection(observation.wind ? observation.wind.dir : '').short,
            windSpeed: helpers.convertMsToMph(observation.wind ? observation.wind.speed : ''),
            windGusts: helpers.convertMsToMph(observation.wind ? observation.wind.gusts : '')
          })
        },
        error => {
          setIsLoaded(true)
          setError(error)
        }
      )

  }, [ lat, lon ])

  
    if (error) return <ErrorComponent />
    if (!isLoaded) return <LoadingComponent />

    return (
      <div className='rightnow'>

        <div className="rightnow_location">
          {currents.location ? <div id='metar-location' className='now'>{currents.location}</div> : ''}
          <p id="metar-timestamp" className="now">{currents.time}</p>
        </div>

        <div className="rightnow_secondrow">
          <div className="rightnow_weather-time">
            <img id="metar-icon" className="metar-icon now" alt="Weather Icon" src={currents.weatherCode} />
          </div>
          <div className="rightnow_city-temp">
            <div id="metar-temp" className="now">{currents.temperature}&deg;</div>
          </div>
          <div className="rightnow_skies-feelslike">
            <p><span className="metar-data now">{currents.weather}</span></p>
            {currents.windChill ? 
              <p><span className='now-label now'>FEELS LIKE</span><span className='metar-data now'>{currents.windChill}&deg;</span></p> : ''}
            {currents.heatIndex ? 
              <p><span className='now-label now'>FEELS LIKE</span><span className='metar-data now'>{currents.heatIndex}&deg;</span></p> : ''}
            {!currents.windChill && !currents.heatIndex ? 
              <p><span className='now-label now'>FEELS LIKE</span><span className='metar-data now'>{currents.temperature}&deg;</span></p> : ''}
          </div>
          <div className="rightnow_wind-dewpoint">
            {(currents.windDirection && currents.windSpeed) && 
              <p><span className='now-label now'>WIND</span><span className='metar-data now'>{currents.windDirection}&nbsp;{currents.windSpeed}</span></p>}
            {currents.windGusts === ' ' ? null : <p><span className='now-label now'>GUSTS</span><span className='metar-data now'>{currents.windGusts}</span></p>}
            {currents.dewpoint ? <p><span className='now-label now'>DEW POINT</span><span className='metar-data now'>{currents.dewpoint}&deg;</span></p> : null}
          </div>
        </div>
        
      </div>
    )

}

